import {
  Camera,
  Video,
  GraduationCap,
  Car,
  User,
  Users,
  PartyPopper,
  Heart,
  Sparkles,
  MapPin,
  Clock,
  Star,
  Instagram,
  Youtube,
  Music2,
  Lock,
  Newspaper,
  Sun,
  CloudSun,
  Cloud,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudRainWind,
  CloudSnow,
  CloudLightning,
  Snowflake,
} from 'lucide-react';

export const ICON_MAP = {
  Camera,
  Video,
  GraduationCap,
  Car,
  User,
  Users,
  PartyPopper,
  Heart,
  Sparkles,
  MapPin,
  Clock,
  Star,
  Instagram,
  Youtube,
  Music2,
  Lock,
  Newspaper,
  Sun,
  CloudSun,
  Cloud,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudRainWind,
  CloudSnow,
  CloudLightning,
  Snowflake,
};

export function getIcon(name) {
  return ICON_MAP[name] || Camera;
}
